// 成績シェアシート（point_calendars/_share_sheet）の開閉・プレビュー・確定・Xポスト・保存・コピー・停止。
// イベントは document に一度だけ委譲する（index.js.erb でボタンが差し替わっても効く）
;(function () {
  'use strict';
  if (window.StatsShareSheet) return;
  window.StatsShareSheet = true;

  var SEL = '#stats-share-modal';
  var state = null; // シートを開いている間だけ持つ
  var previewSeq = 0; // 最後に投げたプレビューだけを反映する

  function $modal() { return $(SEL); }
  // 'a, b' のようにカンマ区切りで複数指定できる
  function $q(names) {
    var sel = names.split(',').map(function (n) { return '.js-stats-share-' + n.trim(); }).join(',');
    return $modal().find(sel);
  }
  function i18n() { return $modal().data('i18n') || {}; }
  function fill(tpl, vars) {
    return Object.keys(vars).reduce(function (s, k) { return s.replace('%{' + k + '}', vars[k]); }, tpl || '');
  }

  function csrf() { return $('meta[name="csrf-token"]').attr('content'); }
  function api(url, opts, accept) {
    opts = opts || {};
    var headers = { 'Accept': accept || 'application/json', 'X-CSRF-Token': csrf() };
    if (opts.body) headers['Content-Type'] = 'application/json';
    return fetch(url, { method: opts.method || 'GET', headers: headers, body: opts.body, credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 401) { location.reload(); return Promise.reject(new Error('unauthorized')); }
        return res;
      });
  }

  function errorMessage(res) {
    return res.json().then(function (j) { return (j.error && j.error.message) || i18n().error_generic; })
      .catch(function () { return i18n().error_generic; });
  }

  // ---- 状態 ----------------------------------------------------------------

  function periodValue(type) { return type === 'month' ? state.month : String(state.year); }
  function currentKey() {
    return [state.type, periodValue(state.type), state.playType, state.showName].join('|');
  }
  function params(extra) {
    var p = { period_type: state.type, period: periodValue(state.type), play_type: state.playType };
    return $.param($.extend(p, extra || {}));
  }
  function periodLabel() {
    return state.type === 'month'
      ? fill(i18n().period_month, { month: state.month.replace('-', '/') })
      : fill(i18n().period_year, { year: state.year });
  }

  function setStatus(msg) { $q('status').text(msg || ''); }
  // 実行後にボタンのアイコンと文言を一時的に差し替える（成績表共有のコピー完了と同じ挙動）
  function flashDone($btn) {
    var $label = $btn.find('.js-stats-share-label');
    var original = $label.data('original') || $label.text();
    $label.data('original', original).text($label.data('done'));
    $btn.find('.js-stats-share-icon').prop('hidden', true);
    $btn.find('.js-stats-share-icon-done').prop('hidden', false);
    clearTimeout($btn.data('timer'));
    $btn.data('timer', setTimeout(function () {
      $label.text(original);
      $btn.find('.js-stats-share-icon').prop('hidden', false);
      $btn.find('.js-stats-share-icon-done').prop('hidden', true);
    }, 2000));
  }
  // 「Xでポストする」と「Xを開く」リンクを入れ替える。url を渡すとリンクを出し、省略するとボタンに戻す
  function toggleOpenX(url) {
    $q('open-x').attr('href', url || '#').prop('hidden', !url);
    $q('x').prop('hidden', !!url);
  }

  function setBusy(busy) {
    state.busy = busy;
    $q('x, save, copy').prop('disabled', busy || !state.previewReady || !state.shareable);
  }

  // ---- 開閉 ----------------------------------------------------------------

  function open(btn) {
    var d = $(btn).data();
    state = {
      type: d.initialPeriodType || 'month', month: d.month, year: d.year, playType: d.playType,
      data: d, showName: true, postText: '', confirmed: {}, share: null, previewReady: false, shareable: true,
      blobUrl: null, opener: btn
    };
    var $m = $modal();
    $m.find('.js-stats-share-hide-name').prop('checked', false);
    toggleRevokeConfirm(false);
    $m.css('display', 'flex').addClass('starting');
    $m.find('.stats-share-modal').addClass('starting');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $m.removeClass('starting').find('.stats-share-modal').removeClass('starting');
        $m.find('.stats-share-modal__title').trigger('focus');
      });
    });
    $('body').css('overflow', 'hidden');
    pushEvent('stats_share_sheet_open', { play_type: state.playType, is_pro: $modal().data('is-pro') === true });
    selectPeriod(state.type);
  }

  function close() {
    var $m = $modal();
    if (!state) return;
    var opener = state.opener;
    revokeBlob();
    previewSeq++;
    state = null;
    $m.addClass('starting').find('.stats-share-modal').addClass('starting');
    setTimeout(function () { $m.css('display', 'none').removeClass('starting').find('.stats-share-modal').removeClass('starting'); }, 250);
    $('body').css('overflow', '');
    if (opener && document.body.contains(opener)) opener.focus();
  }

  function revokeBlob() {
    if (state && state.blobUrl) { URL.revokeObjectURL(state.blobUrl); state.blobUrl = null; }
  }

  // ---- 期間の切り替え・プレビュー ------------------------------------------

  function selectPeriod(type) {
    state.type = type;
    var d = state.data;
    state.shareable = d[type + 'Shareable'] === true || d[type + 'Shareable'] === 'true';
    var reason = d[type + 'Reason'];
    $q('period').each(function () {
      var t = $(this).data('type');
      $(this).text(t === 'month' ? fill(i18n().period_month, { month: state.month.replace('-', '/') }) : fill(i18n().period_year, { year: state.year }))
        .toggleClass('active', t === type).attr('aria-pressed', t === type);
    });
    $q('reason').prop('hidden', state.shareable || !reason).text(reason || '');
    state.share = null;
    $q('revoke-row').prop('hidden', true);
    toggleOpenX();
    $q('manual-url').prop('hidden', true);
    setStatus('');
    if (!state.shareable) { showPreviewError(i18n().preview_failed, false); return; }
    loadPreview();
    loadShareState();
  }

  // previewSeq は loadPreview が加算するので、loadPreview を先に呼んでから呼ぶこと
  function loadShareState() {
    var seq = previewSeq;
    api($modal().data('index-url') + '?' + params({ show_name: state.showName }), {}).then(function (r) { return r.json(); }).then(function (j) {
      if (!state || seq !== previewSeq) return;
      state.share = j.share;
      state.postText = j.post_text || '';
      $q('revoke-row').prop('hidden', !j.share);
    }).catch(function () {});
  }

  function showPreviewError(msg, retry) {
    state.previewReady = false;
    $q('skeleton').prop('hidden', true);
    $q('image').prop('hidden', true);
    $q('preview-error').prop('hidden', false);
    $q('preview-error-text').text(msg);
    $q('retry').prop('hidden', !retry);
    setBusy(false);
  }

  function loadPreview() {
    var seq = ++previewSeq;
    state.previewReady = false;
    $q('skeleton').prop('hidden', false);
    $q('image').prop('hidden', true);
    $q('preview-error').prop('hidden', true);
    setBusy(false);
    api($modal().data('preview-url'), { method: 'POST', body: JSON.stringify({ period_type: state.type, period: periodValue(state.type), play_type: state.playType, show_name: state.showName }) }, 'image/png')
      .then(function (res) {
        if (!res.ok) return errorMessage(res).then(function (m) { throw new Error(m); });
        return res.blob();
      })
      .then(function (blob) {
        if (!state || seq !== previewSeq) return;
        revokeBlob();
        state.blobUrl = URL.createObjectURL(blob);
        $q('image').attr({ src: state.blobUrl, alt: fill(i18n().preview_alt, { period: periodLabel() }) }).prop('hidden', false);
        $q('skeleton').prop('hidden', true);
        state.previewReady = true;
        setBusy(false);
      })
      .catch(function (e) {
        if (!state || seq !== previewSeq || e.message === 'unauthorized') return;
        showPreviewError(e.message && e.message !== 'Failed to fetch' ? e.message : i18n().preview_failed, true);
      });
  }

  // ---- 確定 ----------------------------------------------------------------

  // 確定（作成 or 更新）。同じ期間・対局種別・名前表示の結果は使い回す
  function confirm() {
    var key = currentKey();
    if (state.confirmed[key]) return Promise.resolve(state.confirmed[key]);
    setBusy(true);
    return api($modal().data('create-url'), { method: 'POST', body: JSON.stringify({ period_type: state.type, period: periodValue(state.type), play_type: state.playType, show_name: state.showName }) })
      .then(function (res) {
        if (!res.ok) return errorMessage(res).then(function (m) { throw new Error(m); });
        return res.json();
      })
      .then(function (j) {
        state.confirmed[key] = j;
        pushEvent('stats_share_created', { show_name: state.showName, locale: $modal().data('locale') });
        state.share = { id: j.id, public_url: j.public_url };
        $q('revoke-row').prop('hidden', false);
        setBusy(false);
        return j;
      })
      .catch(function (e) {
        if (state) { setBusy(false); setStatus(e.message === 'Failed to fetch' ? i18n().error_generic : e.message); }
        throw e;
      });
  }

  // 成績表の共有（share_modal.js）と同じ twitter.com/intent/tweet を使う。
  // x.com/intent/post は X アプリが受け取らず、スマホでブラウザ版の X が開く
  function intentUrl(shareUrl) {
    return 'https://twitter.com/intent/tweet?' + $.param({ text: state.postText, url: shareUrl });
  }

  // GA4 イベント（GTM の dataLayer 経由。docs/archive/plans/stats_share/stats_share.md 11章）
  function pushEvent(name, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push($.extend({ event: name, period_type: state.type }, extra || {}));
  }

  function postToX() {
    // スマホ・タブレットは、スクリプトで開いた X の URL が X アプリへ渡らずブラウザ版の X が開く
    // （ユニバーサルリンク・App Links はリンクを直接タップしたときだけ働く）。確定後に「Xを開く」リンクへ差し替えてタップさせる
    if (isTouchPrimary()) {
      confirm().then(function (j) {
        toggleOpenX(intentUrl(j.public_url));
        $q('open-x').trigger('focus');
      }).catch(function () {});
      return;
    }
    // ポップアップブロック対策: クリックと同じ同期処理で先にウィンドウを開く
    var win = window.open('', '_blank');
    confirm().then(function (j) {
      var url = intentUrl(j.public_url);
      if (win) { pushEvent('stats_share_x_click'); win.opener = null; win.location.href = url; }
      else { toggleOpenX(url); }
    }).catch(function () { if (win) win.close(); });
  }

  // スマホ・タブレット（タッチ操作が主の端末）だけ共有シートで保存させる。
  // PC は Web Share に対応していてもそのままダウンロードする
  function isTouchPrimary() {
    return !!window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function saveImage() {
    confirm().then(function (j) {
      var canShareFiles = isTouchPrimary() && navigator.canShare && navigator.share;
      var fallback = function () {
        pushEvent('stats_share_image_save', { method: 'download' });
        var a = document.createElement('a');
        a.href = j.image_url + (j.image_url.indexOf('?') >= 0 ? '&' : '?') + 'download=1';
        a.rel = 'noopener';
        // loading.js が document 上の a[href] クリックでページ遷移用スピナーを出すため、伝播させない
        a.addEventListener('click', function (e) { e.stopPropagation(); });
        document.body.appendChild(a); a.click(); a.remove();
        flashDone($q('save'));
      };
      if (!canShareFiles) return fallback();
      return fetch(j.image_url).then(function (r) { return r.blob(); }).then(function (blob) {
        var file = new File([blob], 'janreco-share.png', { type: 'image/png' });
        if (!navigator.canShare({ files: [file] })) return fallback();
        return navigator.share({ files: [file] }).then(function () { pushEvent('stats_share_image_save', { method: 'web_share' }); flashDone($q('save')); })
          .catch(function (e) { if (e && e.name !== 'AbortError') fallback(); });
      }).catch(fallback);
    }).catch(function () {});
  }

  // Android の Chrome・Safari はタップ直後でないとクリップボードへ書き込めず、確定（画像生成）を待つと猶予が切れる。
  // そのためタップした時点で ClipboardItem に URL の Promise を渡して書き込みを始め、使えない環境では確定後に writeText する
  function canWriteClipboardItem() {
    return !!(window.isSecureContext && window.ClipboardItem && navigator.clipboard && navigator.clipboard.write);
  }

  function copyLink() {
    var urlPromise = confirm().then(function (j) {
      pushEvent('stats_share_link_copy');
      return j.public_url;
    });
    var copied = function () { flashDone($q('copy')); };
    var manual = function (url) {
      $q('manual-url').val(url).prop('hidden', false).trigger('focus').trigger('select');
      setStatus(i18n().copy_manual);
    };
    var write = canWriteClipboardItem()
      ? navigator.clipboard.write([new window.ClipboardItem({
        'text/plain': urlPromise.then(function (url) { return new Blob([url], { type: 'text/plain' }); })
      })])
      : Promise.reject(new Error('ClipboardItem unsupported'));
    write.then(copied, function () {
      // 確定に失敗したときは confirm() がステータスに表示済みなので、ここでは何もしない
      return urlPromise.then(function (url) {
        if (!navigator.clipboard || !navigator.clipboard.writeText) return manual(url);
        return navigator.clipboard.writeText(url).then(copied, function () { manual(url); });
      });
    }).catch(function () {});
  }

  // ---- 停止 ----------------------------------------------------------------

  // 停止確認の表示を切り替える。確認はシートの上に重ねるだけで、シート本体は隠さない
  function toggleRevokeConfirm(show) {
    $q('revoke-confirm').prop('hidden', !show);
  }

  function isRevokeConfirming() { return !$q('revoke-confirm').prop('hidden'); }

  // 確認を閉じてシートに戻る。フォーカスは確認を開いた「共有を停止する」へ戻す
  function cancelRevokeConfirm() {
    toggleRevokeConfirm(false);
    $q('revoke').trigger('focus');
  }

  function revoke() {
    if (!state || !state.share) return;
    api($modal().data('stats-shares-url') + '/' + state.share.id, { method: 'DELETE' }).then(function (res) {
      if (!res.ok && res.status !== 404) return errorMessage(res).then(function (m) { throw new Error(m); });
      pushEvent('stats_share_revoke');
      state.confirmed = {};
      state.share = null;
      toggleRevokeConfirm(false);
      $q('revoke-row').prop('hidden', true);
      toggleOpenX();
      $q('manual-url').prop('hidden', true);
      setStatus(i18n().revoked);
    }).catch(function (e) {
      toggleRevokeConfirm(false);
      setStatus(e.message === 'Failed to fetch' ? i18n().error_generic : e.message);
    });
  }

  // ---- イベント ------------------------------------------------------------

  $(document)
    .on('click', '.js-stats-share-open', function (e) { e.preventDefault(); open(this); })
    .on('click', SEL + ' .js-stats-share-close', close)
    .on('mousedown', SEL, function (e) { if (e.target === this) close(); })
    .on('click', SEL + ' .js-stats-share-period', function () { if (state) selectPeriod($(this).data('type')); })
    .on('click', SEL + ' .js-stats-share-retry', function () { if (state) loadPreview(); })
    .on('change', SEL + ' .js-stats-share-hide-name', function () {
      if (!state) return;
      state.showName = !this.checked;
      toggleOpenX();
      $q('manual-url').prop('hidden', true);
      setStatus('');
      if (state.shareable) { loadPreview(); loadShareState(); }
    })
    .on('click', SEL + ' .js-stats-share-x', function () { if (state && !state.busy) postToX(); })
    .on('click', SEL + ' .js-stats-share-open-x', function () { if (state) pushEvent('stats_share_x_click'); })
    .on('click', SEL + ' .js-stats-share-save', function () { if (state && !state.busy) saveImage(); })
    .on('click', SEL + ' .js-stats-share-copy', function () { if (state && !state.busy) copyLink(); })
    .on('click', SEL + ' .js-stats-share-revoke', function () {
      toggleRevokeConfirm(true);
      // 誤って停止しないよう、キャンセルにフォーカスを置く
      $q('revoke-cancel').trigger('focus');
    })
    .on('click', SEL + ' .js-stats-share-revoke-cancel', cancelRevokeConfirm)
    // 確認カードの外（幕）を押したら確認だけを閉じる
    .on('mousedown', SEL + ' .js-stats-share-revoke-confirm', function (e) { if (e.target === this) cancelRevokeConfirm(); })
    .on('click', SEL + ' .js-stats-share-revoke-ok', revoke)
    .on('keydown', function (e) {
      if (e.key !== 'Escape' || !state) return;
      if (isRevokeConfirming()) { cancelRevokeConfirm(); } else { close(); }
    })
    // キャッシュ復元時に開きっぱなしにならないよう、Turbolinks のキャッシュ前に閉じる
    .on('turbolinks:before-cache', function () {
      if (!state) return;
      revokeBlob(); previewSeq++; state = null;
      $modal().css('display', 'none');
      $('body').css('overflow', '');
    });

  // 公開閲覧ページの計測（/s/:token）
  $(document)
    .on('turbolinks:load', function () {
      var $page = $('[data-stats-share-view]');
      if (!$page.length) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'stats_share_page_view', period_type: $page.data('period-type'), is_owner: $page.data('is-owner') === true });
    })
    .on('click', '[data-stats-share-cta]', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'stats_share_cta_click', cta: $(this).data('stats-share-cta') });
    });
})();
